import { jsxs as i, jsx as t } from "react/jsx-runtime";
import { memo as c } from "react";
import './assets/CartOverviewItem.css';const s = "#ffffff", m = "#396e75", p = "#e5fdff", y = "#546223", l = "#f0fae5", u = "#a65523", d = "#fff1e8", f = "#7f3e3e", g = "#ffe2e2", v = "#62625a", h = "#f8f8e7", z = "#38539a", C = "#707070", V = "#c8f8d1", b = "#87c9c8", k = "#5291b1", x = "rgba(82, 145, 177, 0.1019607843)", w = "#445685", B = "#181d61", O = "rgba(24, 29, 97, 0.1019607843)", U = "#5969d6", G = "#ea999d", R = "#b6577e", W = "rgba(182, 87, 126, 0.1019607843)", A = "#7e3e80", N = "#1e247f", Y = "rgba(30, 36, 127, 0.1019607843)", D = "#da7600", j = "#107f47", I = "#d91734", P = "_html_1ytof_75", S = "_price_summary_container_1ytof_150", q = "_price_summary_container_overview_1ytof_159", E = "_price_summary_container_wrapper_1ytof_165", F = "_price_summary_container_wrapper_section_1_1ytof_173", H = "_price_summary_container_wrapper_section_2_1ytof_173", J = "_price_summary_container_subtotal_1ytof_181", K = "_price_summary_container_total_1ytof_181", L = "_price_summary_container_promotion_1ytof_181", M = "_price_summary_container_expand_promotion_1ytof_181", Q = "_price_summary_container_shipping_1ytof_181", T = "_price_summary_container_pvbvUplift_1ytof_181", X = "_price_summary_container_promotion_text_arrow_1ytof_194", Z = "_price_summary_container_pvbvUplift_text_1ytof_197", $ = "_price_summary_container_pvbvUplift_values_1ytof_200", __ = "_price_summary_container_ApointsCalcDec_1ytof_203", t_ = "_price_summary_container_points_1ytof_206", r_ = "_price_summary_container_expand_1ytof_181", a_ = "_price_summary_container_subtotal_text_1ytof_224", o_ = "_price_summary_container_shipping_text_1ytof_224", e_ = "_price_summary_container_subtotal_amt_1ytof_227", n_ = "_price_summary_container_shipping_amt_1ytof_227", i_ = "_price_summary_container_total_amt_1ytof_230", c_ = "_price_summary_container_border_1ytof_239", s_ = "_price_summary_container_total_amt_strike_1ytof_242", m_ = "_price_summary_container_total_amt_free_1ytof_247", p_ = "_chevron_icon_1ytof_289", _ = {
  amwayWhite: s,
  darkBlue: m,
  lightBlue: p,
  darkGreen: y,
  lightGreen: l,
  darkOrange: u,
  lightOrange: d,
  darkRed: f,
  lightRed: g,
  darkYellow: v,
  lightYellow: h,
  darkPurple: z,
  darkGrayOnWhite: C,
  dataVizColor1: V,
  dataVizColor2: b,
  dataVizColor3: k,
  dataVizColor3Background: x,
  dataVizColor4: w,
  dataVizColor5: B,
  dataVizColor5Background: O,
  dataVizColor6: U,
  dataVizColor7: G,
  dataVizColor8: R,
  dataVizColor8Background: W,
  dataVizColor9: A,
  dataVizColor10: N,
  dataVizColor10Background: Y,
  dataVizAlertOrange: D,
  dataVizSuccessGreen: j,
  dataVizWarningRed: I,
  "no-visible": "_no-visible_1ytof_34",
  html: P,
  "no-cart-selected-text": "_no-cart-selected-text_1ytof_142",
  price_summary_container: S,
  price_summary_container_overview: q,
  price_summary_container_wrapper: E,
  price_summary_container_wrapper_section_1: F,
  price_summary_container_wrapper_section_2: H,
  price_summary_container_subtotal: J,
  price_summary_container_total: K,
  price_summary_container_promotion: L,
  price_summary_container_expand_promotion: M,
  price_summary_container_shipping: Q,
  price_summary_container_pvbvUplift: T,
  price_summary_container_promotion_text_arrow: X,
  price_summary_container_pvbvUplift_text: Z,
  price_summary_container_pvbvUplift_values: $,
  price_summary_container_ApointsCalcDec: __,
  price_summary_container_points: t_,
  price_summary_container_expand: r_,
  price_summary_container_subtotal_text: a_,
  price_summary_container_shipping_text: o_,
  price_summary_container_subtotal_amt: e_,
  price_summary_container_shipping_amt: n_,
  price_summary_container_total_amt: i_,
  price_summary_container_border: c_,
  price_summary_container_total_amt_strike: s_,
  price_summary_container_total_amt_free: m_,
  "not-display-promotion": "_not-display-promotion_1ytof_255",
  "cart-total-checkout-btn-desktop": "_cart-total-checkout-btn-desktop_1ytof_259",
  "shipping-missing-text": "_shipping-missing-text_1ytof_269",
  chevron_icon: p_
}, y_ = c(
  ({ itemName: r, itemValue: a, containerClass: o, itemNameClass: e, itemValueClass: n }) => /* @__PURE__ */ i("div", { className: _[o || ""], children: [
    /* @__PURE__ */ t("div", { className: _[e || ""], children: r }),
    /* @__PURE__ */ t("div", { className: _[n || ""], children: a })
  ] })
);
y_.displayName = "CartOverviewItem";
export {
  y_ as C,
  _ as s
};
//# sourceMappingURL=CartOverviewItem-340549d9.mjs.map
